import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';

import AppDownloadCujModal from '@/components/common/Modal/Cuj/AppDownloadCujModal';
import useModal from '@/hooks/useModal';
import { TrackingInfo, appDownloadCujModalState, setAppDownloadCujModalState } from '@/recoil/atoms/cuj';
import theme from '@/styles/theme';
import { MODAL_TYPE } from '@/types/modal';
import Airbridge from '@/utils/airbridge';

export const MODAL_SHOW_PAGES = [
  { path: '/', link: 'https://abr.ge/fgbb8h' },
  { path: '/content/qna/realtime', link: 'https://abr.ge/xl6mno' },
  { path: '/content/qna/[id]', link: 'https://abr.ge/y2mlu1' },
  { path: '/hospitals', link: 'https://abr.ge/1totxt' },
  { path: '/hospitals/search', link: 'https://abr.ge/a1rxxv' },
  { path: '/hospitals/[hospitalPid]', link: 'https://abr.ge/cmgskv' },
  { path: '/content/magazine', link: 'https://abr.ge/dt8fv1' },
  { path: '/content/magazine/[id]', link: 'https://abr.ge/054rrl' },
  { path: '/content/faq/[id]', link: 'https://abr.ge/rgoppq' },
  { path: '/search', link: 'https://abr.ge/yurdtxu' },
  { path: '/content/qna/ai-answer/[pid]', link: 'https://abr.ge/mwmjor' },
];

const useAppDownloadCujModal = () => {
  const { showModal, closeModal } = useModal();
  const router = useRouter();

  const [_isShow, _setIsShow] = useState(false);
  const appDownloadCujModal = useRecoilValue(appDownloadCujModalState);
  const modalShowPaths = MODAL_SHOW_PAGES.reduce((acc, cur) => {
    return [...acc, cur.path];
  }, [] as string[]);

  const isShowPath = modalShowPaths.includes(router.pathname);

  useEffect(() => {
    if (_isShow && isShowPath && appDownloadCujModal && appDownloadCujModal.isShow) {
      showModal({
        type: MODAL_TYPE.CUSTOM_BACKGROUND,
        props: {
          body: <AppDownloadCujModal />,
          backgroundColor: theme.color.dimmed80,
          onClickOverlay: () => {
            closeModal();
          },
        },
      });
    }
  }, [_isShow, isShowPath, appDownloadCujModal.isShow]);

  useEffect(() => {
    const close = () => {
      closeModal();
    };

    window.addEventListener('popstate', close);

    return () => {
      window.removeEventListener('popstate', close);
    };
  });

  const setIsCujModalTrackingInfo = (params: TrackingInfo) => {
    setAppDownloadCujModalState({
      campaignName: params.campaignName,
      trackContent: params.trackContent,
      contentId: params.contentId,
      contentTitle: params.contentTitle,
      contentCategory: params.contentCategory,
      contentSubCategory: params.contentSubCategory,
    });
  };

  const handleAppDownload = (buttonText?: string) => {
    Airbridge.setDynamicLink({
      campaign: appDownloadCujModal.campaignName || 'unknown',
      content: appDownloadCujModal.trackContent,
      term: buttonText,
      sub_id: appDownloadCujModal.contentId,
      sub_id_1: appDownloadCujModal.contentTitle,
      sub_id_2: appDownloadCujModal.contentCategory,
      ...(appDownloadCujModal.contentSubCategory && { sub_id_3: appDownloadCujModal.contentSubCategory }),
    });
  };

  return {
    setIsCujModalShow: _setIsShow,
    setIsCujModalTrackingInfo,
    handleAppDownload,
  };
};

export default useAppDownloadCujModal;
